import React from "react";
import { Link } from "react-router-dom";
import {
  Cpu, Network, Cloud, ShieldCheck, Phone, Globe, ArrowUpRight, Sparkles,
} from "lucide-react";
import { siteData } from "../mock";
import Starfield from "./Starfield";

const iconMap = { Cpu, Network, Cloud, ShieldCheck, Phone, Globe };

const Services = () => {
  return (
    <section id="services" className="relative py-28 bg-[#05070d] overflow-hidden">
      <Starfield count={40} />
      <div className="aurora float-slow" style={{ width: 380, height: 380, background: "#6366f1", top: "10%", right: "-8%", opacity: 0.28 }} />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/[0.05] border border-white/15 text-[11px] tracking-[0.2em] font-semibold text-blue-300">
              <Sparkles className="w-3 h-3" />
              {siteData.services.heading.toUpperCase()}
            </span>
            <h2 className="mt-4 text-3xl md:text-5xl font-bold tracking-tight text-white">
              A full-stack <span className="gradient-text">IT partner.</span>
            </h2>
            <p className="mt-4 text-white/65 max-w-2xl leading-relaxed">
              {siteData.services.intro}
            </p>
          </div>
          <Link
            to="/service"
            className="inline-flex items-center gap-2 text-blue-400 font-semibold hover:gap-3 hover:text-blue-300 transition-all"
          >
            View all services <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {siteData.services.items.map((svc, i) => {
            const Icon = iconMap[svc.icon] || Cpu;
            return (
              <div
                key={i}
                className="group relative p-6 rounded-2xl grad-border overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_60px_-20px_rgba(59,130,246,0.6)]"
              >
                {/* hover glow */}
                <div className="absolute -inset-px rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: "radial-gradient(600px circle at var(--mx,50%) var(--my,50%), rgba(96,165,250,0.15), transparent 40%)" }} />

                <div className="relative flex items-start justify-between">
                  <div className="relative w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500/25 to-indigo-500/10 border border-blue-400/30 flex items-center justify-center text-blue-300 group-hover:text-white group-hover:from-blue-500 group-hover:to-indigo-500 transition-all">
                    <Icon className="w-5 h-5" strokeWidth={2} />
                  </div>
                  <span className="text-xs font-mono text-white/30 group-hover:text-blue-300 transition-colors">0{i + 1}</span>
                </div>

                <h3 className="relative mt-5 text-lg font-semibold text-white">{svc.title}</h3>
                <p className="relative mt-2 text-sm text-white/65 leading-relaxed">{svc.desc}</p>

                <div className="relative mt-5 flex items-center gap-1.5 text-xs font-semibold text-blue-300 opacity-0 group-hover:opacity-100 transition-opacity">
                  Learn more <ArrowUpRight className="w-3.5 h-3.5" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
